AddressAvailability.Status.Views.SpecialHours = class SpecialHours extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    return this.listenTo(this.model, "change:hours", this.render);
  }

  // RENDERING

  render() {
    this.$el.html(
      window.Sparkle.Client.jstTemplate(this.template)({
        specialHours: this.model.get("specialHours"),
        title: AddressAvailability.Status.t("special_hours_title"),
      }),
    );
    return this;
  }
};
AddressAvailability.Status.Views.SpecialHours.prototype.tagName = "section";
AddressAvailability.Status.Views.SpecialHours.prototype.className =
  "address-availability address-availability--special-hours";
AddressAvailability.Status.Views.SpecialHours.prototype.template =
  "application/components/address_availability/status/templates/special_hours";
